/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketlinklabel2Inputs */

const en_ticketlinklabel2 = /** @type {(inputs: Ticketlinklabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket or sign-up link (optional)`)
};

const de_ticketlinklabel2 = /** @type {(inputs: Ticketlinklabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket- oder Anmeldelink (optional)`)
};

/**
* | output |
* | --- |
* | "Ticket or sign-up link (optional)" |
*
* @param {Ticketlinklabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketlinklabel2 = /** @type {((inputs?: Ticketlinklabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketlinklabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketlinklabel2(inputs)
	return de_ticketlinklabel2(inputs)
});
export { ticketlinklabel2 as "ticketLinkLabel" }